<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-btn
          :color="buttonColor"
          :class="buttonClass"
          dark v-on="{ ...tooltip}"
          v-on:click="()=>dialog=!dialog"
          small
          :icon="buttonIsIcon"
          class='mr-1'
        >
          <v-icon>{{iconName}}</v-icon>
        </v-btn>
      </template>
      <span>{{tooltipText}}</span>
    </v-tooltip>
    <DragForm v-model="dialog">
      <v-card width="750px">
        <v-card-title class="headline">{{title}}</v-card-title>

        <v-card-text>{{text}}
          <v-text-field 
            v-if="hasTextField"
            v-model="textField"
            :label="textLable" 
            :error-messages="errorMessage"
            v-on:blur="onBlur"
            required
          >
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">{{$t(cancelText)}}</v-btn>
          <v-btn 
            color="green darken-1" 
            :disabled="okButtonDisebled"
            text v-on:click="() => {this.$emit('ok', textField); dialog = false;}"
          >{{$t(okText)}}</v-btn>
        </v-card-actions>
      </v-card>
    </DragForm>
  </div>
</template>
<script>
import DragForm from '@/components/Forms/DragForm.vue';
export default {
  components: {
    DragForm,
  },
  props: {
    buttonClass: {
      type: String,
      default: 'mr-0'
    },
    buttonColor: {
      type: String,
      default: 'primary'
    },
    buttonIsIcon: {
      type: Boolean,
      default: false,
    },
    title: String,
    text: String,
    tooltipText: {
      type: String,
      default: null,
    },
    iconName: {
      type: String,
      default: 'mdi-delete'
    },
    textLable: {
      type: String,
      default: '',
    },
    textFieldPattern: {
      type: String,
      default: '',
    },
    errRegexText: {
      type: String,
      default: 'Input error',
    },
    hasTextField: {
      type: Boolean,
      default: false
    },    
    okText: {
      type: String,
      default: 'yes'
    },
    cancelText: {
      type: String,
      default: 'no'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      textField: '',
      wasBlurred: false,
      dialog: false,
      executeButtonClick: false,
    };
  },
  computed: {
    okButtonDisebled(){
      return this.hasTextField && this.checkText(this.textField) !== '';
    },
    errorMessage() {
      const name = this.textField;
      const check = this.executeButtonClick || 
                      this.wasBlurred ||
                      name != null && name.length != 0;
                      
      if (!check)
        return '';

      return this.checkText(name);
    }
  },
  watch: {
    dialog() {
      this.textField = '';
      this.wasBlurred = false;
      this.executeButtonClick = false;
    }
  },
  methods: {
    onBlur() {
      this.wasBlurred = true;
    },
    checkText(value) {
      if (value == null || value.length == 0) {
        return this.$t('validations.notEmpty');
      }

      if (this.textFieldPattern !== '' && value.match(this.textFieldPattern) === null) {
        return this.errRegexText;
      }

      return '';
    },
  },    
};
</script>
